import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
interface SectionProps {
  id: string;
  className?: string;
  children: ReactNode;
}
export const Section = t0 => {
  const $ = _c(7);
  const {
    id,
    className,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={cn("py-80 text-center font-400 text-Gray-550 typo-body2", "mobile-tablet:typo-body3")}>이 섹션을 불러오지 못했어요.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ErrorBoundary fallback={t1}>{children}</ErrorBoundary>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== className || $[4] !== id || $[5] !== t2) {
    t3 = <section id={id} className={className}>{t2}</section>;
    $[3] = className;
    $[4] = id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};